module.exports = __webpack_public_path__ + "img/Brock.0c9a30c7.png";